import type { FC } from "react";
import { useMemo, useState } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";

import { extractPrimaryCategoryFromParams } from "app/pages/industry-analysis/routes/routeUtils";
import categoryService from "app/common/services/categoryService";
import type { WebSource } from "app/components/filters-bar/websource-filter/WebSourceFilter.types";
import { AddToDashboardModalV2 } from "pro-features/components/Modals/src/AddToDashboardModal-v2";
import { AddToDashboardButton } from "app/components/React/AddToDashboard/AddToDashboardButton";
import type { IWidgetModelTypesType } from "app/components/widget/widget-types/Widget";
import { UserCustomCategoryService } from "app/services/category/userCustomCategoryService";

interface IDeviceDistributionAddToDashboardProps {
    metric: string;
    type: IWidgetModelTypesType;
    webSource: WebSource;
}

export const DeviceDistributionAddToDashboard: FC<IDeviceDistributionAddToDashboardProps> = (props) => {
    const { metric, type, webSource } = props;
    const [isOpen, setIsOpen] = useState(false);
    const { params } = useCurrentStateAndParams();

    const getCustomModel = useMemo(() => {
        const { country, duration, category } = params;

        const primaryCategory = extractPrimaryCategoryFromParams(category);
        const categoryId = categoryService.categoryQueryParamToCategoryObject(primaryCategory).id;
        const isCustomCategory = UserCustomCategoryService.isCustomCategory(categoryId);
        const categoryData = isCustomCategory
            ? UserCustomCategoryService.getCustomAndSharedCategoryById(primaryCategory.slice(1))
            : categoryService.getCategory(categoryId);

        const key = isCustomCategory
            ? {
                  id: categoryData.categoryId,
                  name: categoryData.name,
                  category: categoryData.categoryId,
              }
            : {
                  id: `$${categoryData.id}`,
                  name: categoryData.text,
                  category: `$${categoryData.id}`,
              };

        return {
            type: type,
            metric: metric,
            webSource: webSource,
            country: country,
            duration: duration,
            family: "Industry",
            customAsset: "Industry",
            key: [key],
            width: 2,
        };
    }, [params, type, metric, webSource]);

    function onConfirm() {
        setIsOpen(false);
    }

    function handleClose() {
        setIsOpen(false);
    }

    function handleOpenDashboard() {
        setIsOpen(true);
    }

    return (
        <>
            <AddToDashboardButton onClick={handleOpenDashboard} />
            {isOpen ? (
                <AddToDashboardModalV2
                    customModel={getCustomModel as any}
                    onConfirm={onConfirm}
                    onCancel={handleClose}
                />
            ) : null}
        </>
    );
};
